import { Autocomplete, Box, styled } from "@mui/material";
import { APP_COLOR, BORDER_COLOR } from "../../theme";

export const exploreTracksStyles = {
  title: {
    maxWidth: "90px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  } as const,
  bottomContainer: {
    marginTop: "20px",
    display: "flex",
    alignContent: "center",
    justifyContent: "space-between",
  } as const,
  playButton: {
    backgroundColor: "none",
    color: "rgba(255, 255, 255, 0.5)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
  } as const,
  buttonContainer: {
    position: "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
  } as const,
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
  } as const,
  cardContainer: {
    border: `1px solid ${BORDER_COLOR}`,
    height: "300px",
    padding: "20px",
    width: "100%",
    borderRadius: "15px",
    position: "relative",
  } as const,
  loadingContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "20vh",
  } as const,
  containerStyles: {
    position: "relative",
    width: "100%",
    height: "80%",
    borderRadius: "10px",
    overflow: "hidden",
  } as const,
  collaboratorsStyles: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    borderRadius: "5px",
  } as const,
  artistUserNameContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  titleContainer: {
    fontWeight: "bold",
    margin: "10px 0px 10px 0px"
  } as const,
  tooltipBox: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: -2
  } as const,
  filterBox: {
    padding: "15px",
    paddingTop: 0
  } as const,
  titleTypography: {
    fontWeight: "bold",
    marginBottom: "10px",
    marginTop: "10px"
  } as const,
  titleBox: {
    display: "flex",
    flexDirection: "column"
  } as const,
};

export const ContainerForGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  width: "100%",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "30px",
  [theme.breakpoints.down("xl")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(1, 1fr)",
  },
}));

export const ScrollContainer = styled(Box)(({ theme }) => ({
  maxWidth: "100%",
  overflowY: "scroll",
  scrollbarWidth: "none",
  height: "calc(100vh - 180px)",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    height: "calc(100vh - 240px)",
  },
}));


export const SelectField = styled(Autocomplete)({
  color: "white",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "0.5px solid rgba(0,0,0,0,0.2)",
      padding: "20px",
      height: "100%",
    },
    "&:hover fieldset": {
      borderColor: "#a6cfd5",
    },
    "&.Mui-focused fieldset": {
      borderColor: APP_COLOR,
    },
  },
});